<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Пуш-рассылки</h4>
                            <div class="loader" v-if="waiting"></div>
                            <p class="card-category"></p>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('pp_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">В процессе</option>
                                            <option value="2">Отправлено</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-4"></div>
                                <div class="col-md-4">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Создать рассылку
                                    </button>
                                </div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'id'">id</span>
                                        <span v-else-if="column === 'project_id'">проект</span>
                                        <span v-else-if="column === 'locale'">локали</span>
                                        <span v-else-if="column === 'title'">тайтл</span>
                                        <span v-else-if="column === 'text'">текст</span>
                                        <span v-else-if="column === 'push_code'">код пуша</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'created_at'">дата создания</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'translations'">{{ item[column] }}</span>
                                            <span v-else-if="column === ''">
                                                <img class="remove-icon" src="/static/img/delete.png" @click="removeTask(item['id'])"/>
                                            </span>
                                            <span v-else-if="column === 'status'">
                                                <span class="st text-warning" v-if="item[column] === 1">В процессе</span>
                                                <span class="st text-success" v-if="item[column] === 2">Отправлено</span>
                                              </span>
                                            <span v-else-if="column === 'project_id'">
                                                <span class="text-info" v-if="item[column] === 9">Muse</span>
                                              </span>
                                            <span v-else-if="column === 'created_at'">
                                                {{ item[column] | toEasyDate }}
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment/moment";

const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        this.init();
    },
    data() {
        return {
            columns: ['id', 'project_id', 'locale', 'title', 'text', 'push_code', 'status', 'created_at', ''],
            data: [],
            waiting: false,
            status: localStorage.getItem('pp_status') ? localStorage.getItem('pp_status') : "",
            loading: false,
            limit: 10,
            token: localStorage.getItem('token'),
            offset: parseInt(localStorage.getItem('pp_active_offset')) || 0,
        }
    },
    filters: {
        toEasyDate (value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm')
            } else {
                return '';
            }
        },
    },
    methods: {
        init: function () {
            this.get()
        },
        filter: function () {
            localStorage.setItem('pp_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function () {
            this.$router.push('/push-tasks/create');
        },
        get: function () {
            let self = this;

            self.waiting = true;

            axios.get(
                `${this.$hostname}/admin/services/push/tasks`,
                {
                    'params': {
                        status: this.status,
                        limit: self.limit,
                        offset: self.offset,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {
                    self.data = response.data;
                    self.waiting = false;
                })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error)
                })
        },
        removeTask: function (id) {
            let self = this;

            if (confirm("Подтверждение удаление задачи " + id)) {
                self.waiting = true;

                axios.post(
                    `${this.$hostname}/admin/services/push/tasks/delete`,
                    {task_id: id},
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {

                        self.waiting = false;

                        const notification = {
                            template: `<span><b>Задача была успешно удалена</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.get();

                    })
                    .catch(function (error) {

                        self.waiting = false;

                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    });
            }
        },
        prev: function () {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('pp_active_offset', parseInt(this.offset));
            }
        },
        next: function () {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('pp_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('push-tasks') < 1) {
            localStorage.setItem('pp_active_offset', "");
        }
        next();
    },
}
</script>
<style scoped>
.remove-icon {
    cursor: pointer;
    width: 30px;
}
.remove-icon:hover {
    opacity: 0.7;
}
.st {
    font-weight: 700 !important;
}
.pagination-button {
    height: 30px;
    padding: 1px 16px;
    margin-left: 20px;
    color: #fff !important;
}
.pagination-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.mt10 {
    margin-top: 10px;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.loader {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Push.vue